import type { ComponentType } from 'react';
import { VideoIcon } from '@icons/VideoIcon';
import { XOctagonIcon } from '@icons/XOctagonIcon';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { CalendarEvent } from '../../../types';

/**
 * Determine which icon component to display based on event properties
 * Returns the icon component reference (not an element)
 * Consumers render the icon with their own styles
 *
 * @param event - Calendar event
 * @returns Icon component or undefined
 */
export const getEventIcon = (event: CalendarEvent): ComponentType<SvgIconProps> | undefined => {
  const resource = event.resource;

  // No-show appointments get dangerous icon
  if (resource.no_showed === true) {
    return XOctagonIcon;
  }

  // Telehealth appointments get video camera icon
  if (resource.telehealth === true) {
    return VideoIcon;
  }

  // Future: Add icons for other event types
  // @ts-expect-error - Future-proofing for is_suggested property
  if (resource.is_suggested === true) {
    // Future: Star icon for suggestions
    // return StarOutlinedIcon;
  }

  // @ts-expect-error - Future-proofing for needs_reschedule property
  if (resource.needs_reschedule === true) {
    // Future: Circular arrow icon for reschedule requests
    // return LoopIcon;
  }

  // @ts-expect-error - Future-proofing for is_calendar_event property
  if (resource.is_calendar_event === true) {
    // Future: Custom icon for calendar events
    // Could be based on event_type or custom icon field
  }

  return undefined;
};
